import * as consts from '../../constants.js';

export default {
  dataAssociationsStatus: consts.REQUEST_WITHOUT_STARTING,
  associations: [],
};
